"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_BACKGROUND_OPTION = void 0;
var SET_BACKGROUND_OPTION = exports.SET_BACKGROUND_OPTION = 'SET_BACKGROUND_OPTION';